import { render, staticRenderFns } from "./CompleteSurveyMessagePage.vue?vue&type=template&id=2ce80ba8&"
import script from "./CompleteSurveyMessagePage.vue?vue&type=script&lang=ts&"
export * from "./CompleteSurveyMessagePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports